import { Style } from "../../../ducks/style/style";
import { ClassificationParameter, ClassificationParameterExtended } from "../../../interfaces/classification";
import {
  ClassifyAble,
  isTwoDimensionalSymbol,
  LabelType,
  ParameterValue,
  StyleSymbolType,
} from "../../../interfaces/style";
import { unClassify } from "./classifyStyle";
import { symbolParameterWalker } from "./updateSymbolParameter";
import { isLabelParameter } from "../../../utils/isLabelParameter";

export type ParameterValueExtended = ClassifyAble<ParameterValue> | ClassifyAble<StyleSymbolType>;

export const getParameterFromSymbol = <R extends ClassifyAble<ParameterValue>>(
  symbol: StyleSymbolType | LabelType,
  parameter: ClassificationParameterExtended,
): R => {
  let parameterFromSymbol: R;

  symbolParameterWalker((parameterValue: R) => {
    parameterFromSymbol = parameterValue;
  })(symbol, parameter);

  return parameterFromSymbol;
};

export function getParameterFromStyle(
  style: Style,
  children: Style[],
  parameter: ClassificationParameter,
): ParameterValueExtended {
  const { symbol, label, title } = style;

  if (parameter === "symbol") {
    return children?.[0]?.condition
      ? {
          type: "byAttribute",
          defaultValue: unClassify(symbol),
          title,
          values: getSymbolValues(children),
        }
      : unClassify(symbol);
  }

  if (parameter === "size" && isTwoDimensionalSymbol(symbol)) {
    return symbol.width;
  }

  return getParameterFromSymbol(isLabelParameter(parameter) ? label : symbol, parameter);
}

function getSymbolValues(childrenStyles: Style[]) {
  return childrenStyles.map(childStyle => ({
    ...childStyle,
    condition: childStyle.condition,
    title: childStyle.title,
    value: childStyle.symbol,
  }));
}
